"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetFilter = exports.WidgetsEvent = void 0;
var WidgetsEvent;
(function (WidgetsEvent) {
    WidgetsEvent["Add"] = "Add";
    WidgetsEvent["Change"] = "Change";
})(WidgetsEvent || (exports.WidgetsEvent = WidgetsEvent = {}));
;
var WidgetFilter = /** @class */ (function () {
    function WidgetFilter() {
    }
    /**
     * Filter for getting all widgets
     * @returns {(widget: IWidget) => boolean}
     */
    WidgetFilter.all = function () {
        return (function (widget) { return true; });
    };
    /**
     * Filter for getting widget by ID
     * @param id
     */
    WidgetFilter.byId = function (id) {
        return (function (widget) { return widget.id === id; });
    };
    /**
     * Filter for loading widgets by section
     * @param {string} section
     * @returns {(widget: IWidget) => boolean}
     */
    WidgetFilter.bySection = function (section) {
        return (function (widget) {
            return widget.sections !== undefined &&
                widget.sections.filter(function (s) { return s === section; }).length > 0;
        });
    };
    return WidgetFilter;
}());
exports.WidgetFilter = WidgetFilter;
//# sourceMappingURL=IWidgetsManager.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/core/dist/services/IWidgetsManager.js
// module id = 898
// module chunks = 0